import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

// accept a translation review phase
export const acceptTranslationReview = async (translationId: number): Promise<Translation> => {
  const response = await axiosInstance.post<{ data: Translation }>(`/api/translation/phase/accept-review`, {
    translationId,
  });
  return response.data.data;
};
